<template>
  <v-content>
    <v-card width="400" class="mx-auto mt-5">
      <v-card-title>
        <h1 class="title">Change Password</h1>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-text-field
            v-model="oldPassword"
            :rules="passwordRules"
            label="Current password"
            required
            :type="showPassword ? 'text' : 'password'"
            prepend-icon="mdi-lock"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
          />
          <v-text-field
            v-model="password"
            :rules="passwordRules"
            label="New Password"
            required
            :type="showPassword ? 'text' : 'password'"
            prepend-icon="mdi-lock"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
          />
          <v-text-field
            v-model="passwordConfirm"
            :rules="passwordConfirmationRule"
            label="Retype New Password"
            required
            prepend-icon="mdi-lock"
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mx-0 my-2" text to="/">Cancel</v-btn>
        <v-btn class="mx-4 my-2" color="primary" @click="submit" :loading="loading">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-content>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { validationMixin, errorMessageMixin, storeMixin } from "../shared";

export default {
  name: "Password",
  props: {
    adminParam: {
      type: String,
      default: ""
    }
  },
  mixins: [validationMixin, errorMessageMixin, storeMixin],

  async created() {
    if (this.adminParam === "admin") {
      console.log("admin password");
    } else {
      console.log("this.account", this.account);
      if (this.isTeacher && !this.account) {
        console.log("im a teacher with no account");
        await this.loadAccount(this.$store.state.user.id);
        console.log("now this.account", this.account);
      }
    }
  },

  data: () => ({
    loading: false,
    showPassword: false,
    oldPassword: "",
    password: "",
    passwordConfirm: ""
  }),
  computed: {
    ...mapGetters(["isTeacher"]),
    passwordConfirmationRule() {
      return [this.password === this.passwordConfirm || "Passwords must match"];
    }
  },
  methods: {
    ...mapActions(["updatePasswordAction"]),
    reset() {
      this.$refs.form.reset();
    },
    async submit() {
      if (this.$refs.form.validate()) {
        console.log("im submitted");
        let accountId = 0;
        if (this.adminParam === "admin") {
          accountId = this.$store.state.user.id;
        } else {
          accountId = this.$store.state.account.id;
        }
        console.log("accountId", accountId);

        this.$store.state.snackbar = false;
        this.loading = true;
        let changePasswordModel = {
          id: accountId,
          oldPassword: this.oldPassword,
          password: this.password
        };
        try {
          await this.updatePasswordAction({
            model: changePasswordModel,
            token: this.$store.state.token
          });
          this.reset();
          console.log("im setting up the snackbar");
          this.$store.state.error =
            this.adminParam + " Password has been modified.";
          this.$store.state.snackbarColor = "info";
          this.$store.state.snackbar = true;
        } catch (err) {
          this.$store.state.error = this.errorMessage(err);
          this.$store.state.snackbar = true;
          console.log(err);
        }
        this.loading = false;
      }
    }
  }
};
</script>